<template>
    <container :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-5 py-5': $vuetify.breakpoint.mdAndUp,
    }">
    
    <v-layout justify-space-around>   
        <v-flex xs12 sm10>       
            <v-img :src='require("../../../assets/static/img/img-Blog/Post-4.webp")' alt="imagen principal del articulo cuatro del Blog Duo"></v-img>   
        </v-flex>  
    </v-layout>
        <v-layout align-center justify-center row wrap>
                <v-flex class="articulo" justify-center sm10>

                <h1>10 Tips para mudanzas HUM</h1>
                <p> Hágalo Usted Mismo</p>
                <br>
                <p>Es verdad que las mudanzas tienen un montón de costos asociados comenzando con los 
                    trámites, mes de garantía o firma de escritura, luego la larga e interminable lista de 
                    “cositas” en las que debemos pensar: material de embalaje, las cajas, cortinas nuevas, 
                    muebles nuevos, el ganchito para la cocina, alfombra nueva, materiales de aseo, etc.</p>
                <br>
                <p><i>Hágalo usted mismo</i> es una buena opción para ahorrar. Asegúrate de contar con un 
                    batallón de ayudantes proactivos y con distintas cualidades (planificación, fuerza o 
                    técnica, paciencia, motricidad y mucha buena onda) para que apoyen en uno de los 
                    procesos mas importantes de tu vidas. Arrienda un camión con capacidad suficiente para 
                    llevar todo en un solo viaje idealmente, ponte los guantes y manos a la obra.</p>
                <br>
                <p>Te dejamos 10 consejos para que te prepares y todo salga perfecto:</p>
                
                <br>
                <ul>
                    <li><h2>1. Las cosas básicas siempre a mano :</h2></li> 
                    <p> El contrato de arriendo o escritura, el 
                    salvoconducto de mudanzas y tus documentos personales debes tenerlos siempre 
                    a mano, e un lugar visible. Lo recomendable es que dejes todo en un mismo lugar, 
                    junto al teléfono y su cargador, las llaves, remedios y todas esas cosas que son 
                    indispensables. Una mochila o cartera siempre a la vista puede ser la mejor opción.</p>

                    <li><h2>2. Información de contacto :</h2></li> 
                    <p>  Una libreta con los principales teléfonos registrados es 
                        una buena opción en caso de perdida o descarga del teléfono, en el caos ocurre 
                        con mucha frecuencia.</p>

                    <li><h2>3. Cargador de teléfono :</h2></li> 
                    <p>Este será largo y se detiene, el teléfono tampoco. 
                        Seguramente será tu principal herramienta y debe estar siempre cargado. 
                        Mantener un cargador junto a los documentos, la cartera y las llaves es un 
                        accesible</p>

                    <li><h2>4. Despierta temprano :</h2></li> 
                    <p>Vas a querer aprovechar al máximo este día, despierta 
                        temprano, programa todas las alarmas que sean necesarias y aprovecha cada 
                        minuto.</p>  

                    <li><h2>5. Ropa liviana :</h2></li> 
                    <p> Usar ropa informal y zapatos resistentes con planta de goma es lo 
                        adecuado. Las mudanzas son procesos sucios y sudaras aplicas el hágalo usted 
                        mismo. Considera usar guantes, la manipulación de las cajas muchas veces 
                        producen cortes, un par de moretones y como mínimo tus manos quedarán sucias.</p>

                    <li><h2>6. Material de embalaje :</h2></li> 
                    <p>Siempre, siempre, siempre aparecen cosas que olvidamos 
                        embalar. Ten a mano material de embalaje adicional como cajas, cinta adhesiva, 
                        plástico de burbujas, bolsas de basura y plumones </p>    

                    <li><h2>7. Herramientas :</h2></li> 
                    <p> Siempre hay cosas que desarmar o desconectar. Camas, cortinas, 
                        lámparas, artefactos, etc. Destornilladores, alicates, martillo, cinta adhesiva, 
                        cortante para las cajas y tijeras son un buen kit para estar preparado.</p> 

                    <li><h2>8. Refrigerador :</h2></li>
                    <p>Recuerda desconectar el refrigerador y vaciarlo. Guardar el 
                        contenido en un cooler para el traslado es una buena opción.</p>     

                    <li><h2>9. Materiales de aseo :</h2></li>      
                    <p>Con el entusiasmo guardamos todo… pero hay que barrer!! 
                        No pierdas de vista la escoba y la pala, el trapero, algunas toallas húmedas, bolsas 
                        de basura, etc.</p>

                    <li><h2>10. Botiquín :</h2></li>       
                    <p> Tener alcohol, gasas, curitas a mano es una buena idea… las lesiones 
                        ocurren, particularmente cuando hacemos tareas poco habituales como las 
                        mudanzas. Mejor prevenir!! </p>
                </ul>   
                 
                <br>
                <p>Recuerda también dejar un par de vasos o copas a mano y un descorchador… para 
                celebrar al final del día o al menos las copas por si aparece algún espumante. </p>
                <br> 
                <p>Disfruta tu nueva casa… Salud!!!</p>
                <br>   
                <h3>Copyright © DuoApp 2022 </h3> 

                <v-btn @click="retroceder()" style="background-color: #1f97b9; color: #ffffff;">volver</v-btn>

                </v-flex>
        </v-layout>        
    </container>
</template>    
<script>
import { EventBus } from "../../../events.js";
export default {
    data () {
        return{
        }
    },
    methods: {

        retroceder(){
        EventBus.$emit('Retroceder', 1);
      }
    },
    mounted(){
        window.scrollTo(0, 0)
    
    }

}
</script>